import { render, staticRenderFns } from "./sidebarv2.vue?vue&type=template&id=dc611eb4"
import script from "./sidebarv2.vue?vue&type=script&lang=js"
export * from "./sidebarv2.vue?vue&type=script&lang=js"
import style0 from "./sidebarv2.vue?vue&type=style&index=0&id=dc611eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports